<p>
  logged works!
  You are logged now :)
</p>
